
import { samanthaMediaArray } from './samanthaMedia'
import { carrieReviewerProfile, mirandaReviewerProfile, charlotteReviewerProfile } from './samanthaReviewers'
import { samanthaBio, carrieBio, charlotteBio, mirandaBio } from './samanthaBios'
import { samanthaDatingProfileHinge, samanthaDatingProfileBumble, samanthaDatingProfileTinder } from './samanthaDatingProfiles'

export const samanthaUser = {
  _id: 'samanthaUserId',
  email: 'samantha@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...carrieReviewerProfile },
    { ...mirandaReviewerProfile },
    { ...charlotteReviewerProfile }
  ],
  media: [ ...samanthaMediaArray ],
  bio: { ...samanthaBio },
  datingProfiles: [
    { ...samanthaDatingProfileHinge },
    { ...samanthaDatingProfileBumble },
    { ...samanthaDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const carrieUser = {
  _id: 'carrieUserId',
  email: 'carrie@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...carrieBio },
  datingProfiles: [],
  reviewerProfile: { ...carrieReviewerProfile },
}

export const mirandaUser = {
  _id: 'mirandaUserId',
  email: 'miranda@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...mirandaBio },
  datingProfiles: [],
  reviewerProfile: { ...mirandaReviewerProfile },
}

export const charlotteUser = {
  _id: 'charlotteUserId',
  email: 'charlotte@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...charlotteBio },
  datingProfiles: [],
  reviewerProfile: { ...charlotteReviewerProfile },
}
